import { flag } from 'country-emoji';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';



const formatLocation = ({address_line, address_city, address_country}) => {
  if (!address_line) {
    if (!address_city && !address_country) {
      return '-';
    }
    return `${address_city}, ${address_country} ${flag(address_country)}`;
  }

  return `${address_line} - ${address_city}, ${address_country} ${flag(address_country)}`;
};

const SideContainer = styled.div`
  vertical-align: top;
  display: inline-block;
  padding-left: 0px;
  width: 40%;
`;

const ListPill = styled.span`
  background: ${props => props.theme.enigmaGreyLight};
  font-size: 14px;
  margin: 5px 0px;
  padding: 5px 0px;
  border-radius: 3px;
  display: inline-block;
`;

const DetailLineItem = styled.div`
  color: ${props =>
    props.isDefault ? props.theme.enigmaBlack : props.theme.enigmaGrey};
  padding: 10px 5px;
  font-size: 16px;
  line-height: 32px;
`;

const LeftBox = styled.div`
  vertical-align: top;
  display: inline-block;
  border: ${props => props.theme.borderMd};
  border-radius: 2px;
  padding: 10px;
  table tr {
    border-bottom: ${props => props.theme.borderMd};
    td {
      padding: 10px 5px 5px 0px;
      code {
        font-family: 'GT Mono', monospace;
      }
    }
  }

  a {
    font-size: ${props => props.theme.font.fontSm};
    color: ${props => props.theme.enigmaBlue};
  }
`;

const LeftContainer = styled.div`
  display: inline-block;
  width: 60%;
`;

const wipeNullValues = nameString => {
  if (!nameString) return '';
  if (nameString === null) return '';
  if (nameString === 'null') return '';
  return nameString;
};

const formatCountry = ({ country_name, country_type }) => (
  <span>
    {country_name} ({country_type}) {flag(country_name)}
  </span>
);

const formatName = ({
  name_type,
  title_honorific,
  first_name,
  middle_name,
  surname,
  suffix,
}) => (
  <tr>
    <td>{name_type}&nbsp;</td>
    <td>
      <code>{`${wipeNullValues(title_honorific)} ${wipeNullValues(
        first_name
      )} ${wipeNullValues(middle_name)} ${wipeNullValues(
        surname
      )} ${wipeNullValues(suffix)}`}</code>
    </td>
  </tr>
);

const formatLists = listItem => (
  <li>
    <ListPill>{listItem}</ListPill>
  </li>
);

function SanctionsDetails({
  names,
  sanctions_lists,
  countries,
  location,
  nationality,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => setIsExpanded(!isExpanded);
  const isExpandable = names.length > 2;
  const namesTrimmed = isExpanded ? names : names.slice(0, 2);
  const formattedLocation = formatLocation(location);
  const CountryWidget = (
    <DetailLineItem isDefault={countries && countries.length}>
      Countries:{' '}
      {countries && countries.length ? countries.map(formatCountry) : '-'}
    </DetailLineItem>
  );
  const NationalityWidget = (
    <DetailLineItem isDefault={nationality && nationality.length}>
      Nationality: {nationality || '-'} {flag(nationality)}
    </DetailLineItem>
  );
  const LocationWidget = (
    <DetailLineItem isDefault={formattedLocation.length > 1}>
      Location: {formattedLocation}
    </DetailLineItem>
  );
  return (
    <div>
      <LeftContainer>
        <LeftBox>
          <table>
            <tbody>{namesTrimmed.map(formatName)}</tbody>
          </table>
          {isExpandable && (
            <a onClick={toggleExpanded}>
              {isExpanded ? 'Show Less' : 'Show More'}
            </a>
          )}
        </LeftBox>
        <div>
          {CountryWidget}
          {NationalityWidget}
          {LocationWidget}
        </div>
      </LeftContainer>
      <SideContainer>
        <div>Dow Jones Watchlists</div>
        <ul>{sanctions_lists.map(formatLists)}</ul>
      </SideContainer>
    </div>
  );
}

SanctionsDetails.propTypes = {
  names: PropTypes.arrayOf(
    PropTypes.shape({
      first_name: PropTypes.string,
      middle_name: PropTypes.string,
      name_sub_type: PropTypes.string,
      name_type: PropTypes.string,
      suffix: PropTypes.string,
      surname: PropTypes.string,
      title_honorific: PropTypes.string,
    })
  ),
  sanctions_lists: PropTypes.array,
};

SanctionsDetails.defaultProps = {
  names: [],
  sanctions_lists: [],
};

export default SanctionsDetails;
